import { QueryHookOptions } from '@apollo/client';

import { PaginationInfo, usePaginatedQuery } from '@occc-app/hooks/usePaginatedQuery';
import {
  KioskAdSetFilter,
  useKioskAdSetsQuery,
  KioskAdSetsQuery,
  KioskAdSetFragment,
} from '@occc/graphql';

type GetAdSetsProps = {
  filter: KioskAdSetFilter;
  pageSize?: number;
  baseOptions?: QueryHookOptions;
  paginationInfo?: PaginationInfo;
  onPageChange?: (info: PaginationInfo) => void;
};

export const transformDataToAdSetsArray = (
  data?: KioskAdSetsQuery,
): KioskAdSetFragment[] | undefined => data?.kioskAdSets.edges.map((e) => e.node);

export const useGetAdSets = ({
  filter,
  pageSize,
  baseOptions,
  paginationInfo,
  onPageChange,
}: GetAdSetsProps) => {
  const response = usePaginatedQuery(
    useKioskAdSetsQuery,
    'kioskAdSets.pageInfo',
    pageSize,
    {
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      variables: {
        filter,
      },
      ...baseOptions,
    } as QueryHookOptions,
    paginationInfo,
    onPageChange,
  );

  return {
    ...response,
    data: transformDataToAdSetsArray(response.data),
  };
};
